/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuthResponseDto } from '../../models/auth-response-dto';

export interface AuthExternalProviderPost$Json$Params {
  provider: string;
}

export function authExternalProviderPost$Json(http: HttpClient, rootUrl: string, params: AuthExternalProviderPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthResponseDto>> {
  const rb = new RequestBuilder(rootUrl, authExternalProviderPost$Json.PATH, 'post');
  if (params) {
    rb.path('provider', params.provider, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AuthResponseDto>;
    })
  );
}

authExternalProviderPost$Json.PATH = '/auth/external/{provider}';
